import { platformApprovedActionProviderDescriptorSchema, platformApprovedActionProviderRequestSchema, platformApprovedActionProviderResultSchema, platformApprovedActionProviderSlot, platformOptionalActionProviderHostCapability, } from '@crest/platform-contracts/hosts';
import { z } from 'zod';
export const tasksTaskReversalActionsProviderId = 'tasks.task-reversal-actions';
export const tasksTaskReversalActionsCapability = 'tasks.task-reversal-actions.v1';
export const tasksTaskReversalActionsSlot = platformApprovedActionProviderSlot;
export const tasksCancelCreatedTaskActionId = 'tasks.cancel-created-task.v1';
/**
 * Frozen input for the owner-specific compensation of a task created by a
 * Workflow execution. The task identity is duplicated intentionally: the
 * host target and this input must agree before the owner is called.
 */
export const tasksCancelCreatedTaskInputSchema = z.strictObject({
    targetTaskId: z.string().uuid(),
    originalExecutionId: z.string().uuid(),
    // Tasks revisions are PostgreSQL int4. Pin the public contract to the same
    // bound so a schema-valid request cannot fail later during SQL coercion.
    expectedRevision: z.number().int().positive().max(2_147_483_646),
    reason: z.string().trim().min(5).max(2_000),
    // Kept within Platform evidence metadata's 500-character bound so a
    // validated owner success cannot fail during result/evidence encoding.
    compensationSummary: z.string().trim().min(1).max(500),
});
/** sha256 of the canonical input JSON-Schema artifact; this is frozen for v1. */
export const tasksCancelCreatedTaskInputSchemaHash = 'da76cfdc71f9a0a096b4c8dcdce801e725d5ce62f3d45fa3a59ae039fca296fb';
export const tasksTaskReversalActionsDescriptor = platformApprovedActionProviderDescriptorSchema.parse({
    kind: 'descriptor',
    contractVersion: platformOptionalActionProviderHostCapability,
    providerId: tasksTaskReversalActionsProviderId,
    providerCapability: tasksTaskReversalActionsCapability,
    displayName: 'Tasks task-reversal actions',
    actions: [{
            actionId: tasksCancelCreatedTaskActionId,
            displayName: 'Cancel workflow-created task',
            targetResourceType: 'tasks.task',
            inputSchemaHash: tasksCancelCreatedTaskInputSchemaHash,
            requiredPermission: 'tasks.tasks.cancel',
            assistantPolicy: {
                policyContractVersion: 'platform.assistant-action-policy.v1',
                confirmation: 'explicit',
                effectClass: 'compensating-write',
                externalEffectClass: 'none',
                // Cancellation has no generic reopen/reversal registration. This is
                // truthful metadata; it does not claim global MW-032/MW-033 closure.
                reversal: { kind: 'compensating-action', registeredReversalActionId: null },
                ownerReadbackRequired: true,
                inputSchemaHash: tasksCancelCreatedTaskInputSchemaHash,
            },
        }],
});
export const tasksTaskReversalActionsRequestSchema = platformApprovedActionProviderRequestSchema;
export const tasksTaskReversalActionsResultSchema = platformApprovedActionProviderResultSchema;
//# sourceMappingURL=tasks-task-reversal-actions.contract.js.map